import React, { useEffect, useState } from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { Entente } from '../../../../../../common/src/entities';
import { DateTime } from 'luxon';
import logo from '../../../../../public/SA_vertical_CA_couleur.png';

const styles = StyleSheet.create({
    page: { padding: 20 },
    title: { textAlign: 'center', fontSize: 20, fontWeight: 'bold' },
    subtitle: { textAlign: 'center', fontSize: 14, marginBottom: 10, color: 'grey' },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 1,
        width: 280,
    },
    logo: { width: 200, height: '100%' },
    contactInfo: { textAlign: 'right', fontSize: 10 },
    borderedBlock: {
        borderWidth: 1,
        borderColor: 'black',
        padding: 5,
        marginBottom: 5,
    },
    row: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 1 },
    column: { width: '49%' },
    label: { fontWeight: 'bold', fontSize: 10 },
    value: { fontWeight: 'normal', fontSize: 10, maxLines: 1 },
    sectionTitle: { textAlign: 'center', fontSize: 16, fontWeight: 'bold', marginTop: 5, color: '#1f487c' },
});

export function beautifyType(type: string) {
    switch (type) {
        case 'soumission':
            return 'Soumission';
        case 'reservation':
            return 'Contrat de Réservation';
        case 'bonDeCommande':
            return 'Bon de commande';
        case 'facture':
            return 'Facture';
        case 'etatDeCompte':
            return 'État de Compte';
        default:
            return type;
    }
}

const FitText = ({ text, maxWidth }) => {
    let fontSize = 10;

    const adjustFontSize = () => {
        let newFontSize = 10;
        let textWidth = text.length * newFontSize * 0.5;

        while (textWidth > maxWidth && newFontSize > 5) {
            newFontSize -= 1;
            textWidth = text.length * newFontSize * 0.5;
        }

        fontSize = newFontSize;
    };

    adjustFontSize();

    return <Text style={{ fontSize }}>{text}</Text>;
};

export default function CommonHeaderPDF({ entente, type }: { entente: Entente; type: string }) {
    const beautifiedType = beautifyType(type);

    return (
        <>
            <Text style={styles.title}>{beautifiedType}</Text>
            <Text style={styles.subtitle}>Contrat de {beautifiedType.toLowerCase()}</Text>

            <View style={styles.header}>
                <View style={styles.logo}>
                    <Image src={logo} />
                </View>
                <View style={styles.contactInfo}>
                    <Text>9379-8940 Québec inc. (SOLUTION ANIMATION)</Text>
                    <Text>7905 rue Boyer, Montréal, Québec, H2R 2S3</Text>
                    <Text>514-942-5155</Text>
                    <Text>isaacbarbe@solutionanimation.com</Text>
                    <Text>www.solutionanimation.com</Text>
                    <Text>NEQ 1173738098</Text>
                </View>
            </View>

            <View style={styles.borderedBlock}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                    <View style={styles.column}>
                        <View style={styles.row}>
                            <Text style={styles.label}>Date d'émission:</Text>
                            <FitText
                                text={DateTime.local()
                                    .setLocale('fr')
                                    .toLocaleString({ month: 'numeric', day: 'numeric', year: 'numeric' })}
                                maxWidth={180}
                            />
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Numéro d'entente:</Text>
                            <FitText text={entente.id} maxWidth={180} />
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Client:</Text>
                            <FitText text={entente.client.name} maxWidth={180} />
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Adresse client:</Text>
                            <FitText
                                text={
                                    entente.adresse_facturation?.adresse ??
                                    entente.client.adresse_facturation?.adresse ??
                                    entente.client.lieux[0]?.lieu?.adresse ??
                                    'NA'
                                }
                                maxWidth={180}
                            />
                        </View>
                    </View>
                    <View style={styles.column}>
                        <View style={styles.row}>
                            <Text style={styles.label}>Contact:</Text>
                            <FitText text={entente.client.contacts[0]?.contact.name ?? 'NA'} maxWidth={180} />
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>#Téléphone:</Text>
                            <FitText text={entente.client.contacts[0]?.contact.telephone ?? 'NA'} maxWidth={180} />
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Courriel:</Text>
                            <FitText text={entente.client.contacts[0]?.contact.email ?? 'NA'} maxWidth={180} />
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Statut abonnement:</Text>
                            <FitText text={entente.statut ?? 'NA'} maxWidth={180} />
                        </View>
                    </View>
                </View>
            </View>

            <Text style={styles.sectionTitle}>{entente.name}</Text>
        </>
    );
}
